/* eslint-disable no-console */
import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';

export const getPom = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.POM.GET_ALL_POM}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getGrading = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.POM.GET_GRADING_GROUP}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getGradingName = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.POM.GET_GRADING_NAME}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const sendLibId = async (data, id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.POM.EDIT_GRADING_GROUP}/${id}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addLibId = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.POM.ADD_GRADING_GROUP}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uniquePomCode = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.POM.UNIQUE_POM_CODE}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addPom = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.POM.ADD_POM}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updatePom = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.POM.UPDATE_POM}${data._id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePom = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.POM.DELETE_POM}${data.deleteId}`, {
      params: {
        loggedInUserId: data.loggedInUserId,
        multipleDelete: data.multipleDelete,
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const multiDeletePom = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.POM.MULTI_DELETE_POM}`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchGradingBrand = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_BRANDS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchGradingCategoryOne = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_CATEGORY_1}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchGradingById = async (id, data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.POM.GRADING}/${id}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveGradingGroup = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.POM.GRADING}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePomsFromGradingGroup = async (gradingLibraryId, pomIds) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.POM.GRADING_GROUP_POMS}/${gradingLibraryId}/poms`, {
      params: { pomIds: pomIds.join(',') },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUnitOfMeasure = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_FETCH_UNIT_OF_MEASURE.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkEComSpec = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.SET_MASTER_ACCESS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchEComSpecFromMaster = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MEASUREMENT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const checkGradingGroupExistInProduct = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GRADING}/${id}/check-gradings-ref`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadPOMXlsxFileService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.POM.POM_EXCEL_SHEET_UPDATE}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const companyDefaultUnit = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PURCHASE_ORDER.FETCH_PROFILE}`, { id: 'Personalise' });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const gradingGroupData = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GRADING}`, { params: { ...payload } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteGradingGroup = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DEVELOPMENT_ORDER.GRADING}`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateGrading = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.POM.DUPLICATE_GRADING}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const updateGradingStatus = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.POM.UPDATE_GRADING_STATUS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportExcelService = async (data) => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.POM.DOWNLOAD_POM_LIBRARY}`, data, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const uploadFile = async (data) => {
  const loginFormData = new FormData();
  loginFormData.append('xls', data.xls);
  try {
    return await apiClient.post(`${apiEndpoint}${API.POM.UPLOAD_POM_EXCELSHEET}`, loginFormData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const savePomGroup = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.POM.SAVE_POM_GROUP}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPomGroupById = async (id, obj) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.POM.SAVE_POM_GROUP}/${id}`, { params: { ...obj } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPomGroupdata = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.POM.GET_POM_GROUPS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchPomGroupsWithPomLibrary = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.POM.FETCH_POM_GROUPS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePomGroups = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.POM.GET_POM_GROUPS}`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const downloadGradingSampleFile = async (data) => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.POM.DOWNLOAD_SAMPLE_FILES}`, data, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};
